/**
 * View component for /locations/:locationId/update
 *
 * Updates a single siteLocation from a copy of the selcted siteLocation
 * as defined in the siteLocation reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as siteLocationActions from '../siteLocationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import utilities
import mapUtils from '../../../global/utils/mapUtils';

// import module components
import SiteLocationForm from '../components/SiteLocationForm.js.jsx';
import SiteLocationLayout from '../components/SiteLocationLayout.js.jsx';

// import siteLocation css modules
import siteLocationStyles from '../siteLocationModuleStyles.css';

class AdminUpdateSiteLocation extends Base {
  constructor(props) {
    super(props);
    const { selectedSiteLocation, siteLocationMap } = this.props;
    this.state = {
      siteLocation: siteLocationMap[selectedSiteLocation.id] ?  _.cloneDeep(siteLocationMap[selectedSiteLocation.id]) : {}
      // NOTE: we don't want to change the store, just make changes to a copy
      , formHelpers: {}
      /**
       * NOTE: formHelpers are useful for things like radio controls and other
       * things that manipulate the form, but don't directly effect the state of
       * the siteLocation
       */
    }
    this._bind(
      '_handleFormChange'
      , '_handleMapSearch'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(siteLocationActions.fetchSingleIfNeeded(match.params.siteLocationId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedSiteLocation, siteLocationMap } = nextProps;
    console.log(selectedSiteLocation);
    this.setState({
      siteLocation: siteLocationMap[selectedSiteLocation.id] ? _.cloneDeep(siteLocationMap[selectedSiteLocation.id]) : {}
      //we don't want to actually change the store's siteLocation, just use a copy
      , formHelpers: {}
    })
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, () => {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleMapSearch(mapObj) {
    // console.log(mapObj);
    let newSiteLocation = _.cloneDeep(this.state.siteLocation);
    newSiteLocation.formatted_address = mapObj[0].formatted_address;
    newSiteLocation.address = mapUtils.extractAddress(mapObj[0].address_components);
    newSiteLocation.geo.coordinates[0] = mapObj[0].geometry.location.lng();
    newSiteLocation.geo.coordinates[1] = mapObj[0].geometry.location.lat();
    newSiteLocation.mapZoom = 16;
    this.setState({siteLocation: newSiteLocation});
    // console.log(newSiteLocation);
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(siteLocationActions.sendUpdateSiteLocation(this.state.siteLocation)).then((action) => {
      if(action.success) {
        history.push(`/admin/site-locations/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  render() {
    const { location, selectedSiteLocation } = this.props;
    const { siteLocation, formHelpers } = this.state;
    const isEmpty = (!siteLocation || siteLocation._id === null || siteLocation._id === undefined);
    return  (
      <div className="flex">
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs}/>
          </div>
          {isEmpty ?
            (selectedSiteLocation.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
            :
            <SiteLocationForm
              siteLocation={siteLocation}
              cancelLink={`/admin/site-locations/${siteLocation._id}`}
              formHelpers={formHelpers}
              formTitle="Update Site/Team Location"
              formType="update"
              handleFormChange={this._handleFormChange}
              handleMapSearch={this._handleMapSearch}
              handleFormSubmit={this._handleFormSubmit}
            />
          }
        </section>
      </div>
    )
  }
}

AdminUpdateSiteLocation.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedSiteLocation: store.siteLocation.selected
    , siteLocationMap: store.siteLocation.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminUpdateSiteLocation)
);



// WEBPACK FOOTER //
// modules/siteLocation/views/AdminUpdateSiteLocation.js.jsx